import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hello there 👋, I’m <span className="purple">Sheldon Onzere</span> from 
            <span className="purple"> Nairobi, Kenya</span>.<br />
            I’m a passionate <b>Full-Stack & Mobile Developer</b> with a creative mind for building 
            intelligent digital experiences. I love transforming ideas into seamless, 
            data-driven, and visually appealing applications.
            <br /><br />
            Currently pursuing a <b>BSc. in Computer Science</b> in Baringo County, 
            and a graduate of <b>Modcom Institute of Technology</b>’s Software Development program.
            <br />
            <br />
            My focus areas include:
            <ul>
              <li><ImPointRight /> AI-assisted education platforms & automation</li>
              <li><ImPointRight /> FinTech and financial analytics apps</li>
              <li><ImPointRight /> Cloud-integrated school ERP systems</li>
              <li><ImPointRight /> IoT & robotics (Arduino projects)</li>
              <li><ImPointRight /> Cross-platform mobile app development</li>
            </ul>
            <br />
            Outside coding, I enjoy:
            <ul>
              <li className="about-activity"><ImPointRight /> Playing video games </li>
              <li className="about-activity"><ImPointRight /> Watching tech & sci-fi films</li>
              <li className="about-activity"><ImPointRight /> Repairing and tinkering with gadgets</li>
            </ul>
            <br />
            <i style={{ color: "#FF3000" }}>
              "Building digital solutions that bridge creativity, technology, and real-world impact."
            </i>
            <footer className="blockquote-footer" style={{marginTop: "10px"}}>Sheldon Onzere</footer>
          </p>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
